import React from "react"
import './Footer.scss';
function Footer(){
    return (<div className="footer">
        <p>@2023 made by Zhihao Wang</p>
    </div>)
}

export default Footer